/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationResponse,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData401,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData403,
} from '../types/TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData.ts';

function getTelegramAuthTelegramAuthorizeByTelegramWidgetDataUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/telegram/login-widget` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/telegram/login-widget}
 */
export async function telegramAuthTelegramAuthorizeByTelegramWidgetData(
  data: TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest,
  config: Partial<RequestConfig<TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData401
      | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData403
    >,
    TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthTelegramAuthorizeByTelegramWidgetDataUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
